var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-insurance",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security-safe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_66",
    "data-name": "Subtraction 66",
    d: "M11.168,24.325a2.5,2.5,0,0,1-.639-.082,14.58,14.58,0,0,1-7.544-4.957A13.238,13.238,0,0,1,0,11.089V5.747A2.923,2.923,0,0,1,1.73,3.24L8.711.465a6.687,6.687,0,0,1,4.9,0L20.593,3.24a2.919,2.919,0,0,1,1.742,2.507v5.342a13.238,13.238,0,0,1-2.985,8.2,14.58,14.58,0,0,1-7.544,4.957A2.5,2.5,0,0,1,11.168,24.325ZM6.7,9.725a1,1,0,0,0-1,1v1.54a1,1,0,0,0,1,1H9.343V15.8a1,1,0,0,0,1,1h1.646a1,1,0,0,0,1-1v-2.54h2.648a1,1,0,0,0,1-1v-1.54a1,1,0,0,0-1-1H12.989V7.186a1,1,0,0,0-1-1H10.343a1,1,0,0,0-1,1v2.54Z",
    transform: "translate(2.833 1.84)",
    fill: "#222227"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsurance);
export default __webpack_public_path__ + "static/media/icon-insurance.548004dbc3ac8b9cff3c136c0740b589.svg";
export { ForwardRef as ReactComponent };